import { Formatter } from './index';

export const capitalizeFormatter: Formatter = (value) => {
    if (typeof value !== 'string' || !value) {
        return null;
    }
    return `${value[0].toUpperCase()}${value.substring(1)}`;
};
